<script setup lang="ts">
import { useInjectedColor } from '~/composables/useInjectedColor'
import type { UIProp } from '~/types/elementsUi'

interface VRadioProps {
  label?: string
  srLabel?: string
  name: string // Name of the group
  value: string | boolean | number | null // Name of this option
  disabled?: boolean

  ui?: UIProp<'label' | 'button'>
}

const props = defineProps<VRadioProps>()

const modelValue = defineModel<any>({ required: true })

const { t, te } = useI18n()

const $field = useInjectedColor()
const $form = useInjectedId(props.name)

const baseId = computed(() => {
  if (!$form) {
    return undefined
  }

  return $form.elementId.value
})

const computedColor = computed(() => {
  if ($field.color?.value) {
    return $field.color.value
  }

  return 'default'
})
</script>

<template>
  <label
    class="radio"
    :class="[disabled && 'disabled', ui?.label]"
    :for="`${baseId}-${value}`"
    :aria-disabled="disabled"
  >
    <input
      :id="`${baseId}-${value}`"
      v-model="modelValue"
      type="radio"
      class="radio-input"
      :class="computedColor"
      :name
      :value
      :disabled
    />
    <span class="radio-element" :class="ui?.button" />
    <slot>
      <span v-if="label">
        {{ te(label) ? t(label) : label }}
      </span>
    </slot>
    <span v-if="srLabel" class="sr-only">{{ te(srLabel) ? t(srLabel) : srLabel }}</span>
  </label>
</template>

<style scoped></style>
